function escapeRegExp(string: string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlight(text?: string, search?: string) {
  if (!text || !search) {
    return text;
  }

  const safeSearch = escapeRegExp(search);
  const parts = text.split(new RegExp(`(${safeSearch})`, "gi"));

  return parts.map((part, i) =>
    part.toLowerCase() === search.toLowerCase() ? (
      <span key={i} style={{ backgroundColor: "yellow" }}>
        {part}
      </span>
    ) : (
      part
    )
  );
}
